<template>
    <Progressbar v-if="loading && !opportunity.currency" />
    <NetworkError v-else-if="!opportunity.currency && errors" @tryAgain="getData" />
    <div class="w-full h-full bg-gray-200 dark:bg-base-100 rounded-tr-3xl xl:px-9 pt-6 lg:pt-10 pb-14 " v-else>
        <div class="container">
            <section class="lg:grid lg:grid-cols-24 lg:gap-6 flex flex-col">
                <div class="xl:col-span-6 col-span-8 lg:mb-0 mb-5">
                    <ul class="text-lg hidden lg:block">
                        <li class="mb-2 last:mb-0">
                            <button
                                :class="{ '!text-blue-700 !border-blue-700 !border-opacity-100 dark:!border-blue-700': step === 1 }"
                                @click="setStep(1)"
                                class="step-1 px-6 w-full font-medium py-4 transition duration-200 border-opacity-25 text-gray-60  border-gray-300 group  border-2 bg-white dark:bg-base-300 dark:border-transparent  rounded-2xl flex items-center">
                                <span :class="{ '!bg-blue-700 !bg-opacity-100': step == 1 }"
                                    class="w-9 bg-gray-350 group-hover:bg-opacity-100 transition duration-200 h-9 ml-4 flex items-center justify-center rounded-lg bg-opacity-50">
                                    <InformationCircleIcon class="w-5 h-5 text-white" />
                                </span>
                                {{ __('Opportunity information') }}
                            </button>
                        </li>
                        <li class="mb-2 last:mb-0">
                            <button
                                :class="{ '!text-blue-700 !border-blue-700 !border-opacity-100 dark:!border-blue-700': step === 2 }"
                                @click="setStep(2)"
                                class="step-2 px-6  w-full font-medium py-4 transition duration-200 border-opacity-25 text-gray-60  border-gray-300  group group bg-white dark:bg-base-300 dark:border-transparent border-2 rounded-2xl  flex items-center">
                                <span
                                    :class="{ '!bg-blue-700 !bg-opacity-100': step == 2, 'group-hover:bg-opacity-100': step > 2 }"
                                    class="w-9 bg-gray-350 transition duration-200  h-9 ml-4 flex items-center justify-center rounded-lg bg-opacity-50">
                                    <ClipboardDocumentListIcon class="w-5 h-5 text-white" />
                                </span>
                                {{ __('More information') }}
                            </button>
                        </li>
                        <li class="mb-2 last:mb-0">
                            <button
                                :class="{ '!text-blue-700 !border-blue-700 !border-opacity-100 dark:!border-blue-700': step === 3 }"
                                @click="setStep(3)"
                                class="step-3 px-6  w-full font-medium py-4 transition duration-200 border-opacity-25 text-gray-60  border-gray-300  group group bg-white dark:bg-base-300 dark:border-transparent border-2 rounded-2xl  flex items-center">
                                <span
                                    :class="{ '!bg-blue-700 !bg-opacity-100': step == 3, 'group-hover:bg-opacity-100': step > 3 }"
                                    class="w-9 bg-gray-350 transition duration-200  h-9 ml-4 flex items-center justify-center rounded-lg bg-opacity-50">
                                    <ShoppingBagIcon class="w-5 h-5 text-white" />
                                </span>
                                {{ __('Products') }}
                            </button>
                        </li>
                        <li class="mb-2 last:mb-0">
                            <button
                                :class="{ '!text-blue-700 !border-blue-700 !border-opacity-100 dark:!border-blue-700': step === 4 }"
                                @click="setStep(4)"
                                class="step-4 px-6  w-full font-medium py-4 transition duration-200 border-opacity-25 text-gray-60  border-gray-300  group group bg-white dark:bg-base-300 dark:border-transparent  rounded-2xl border-2  flex items-center">
                                <span
                                    :class="{ '!bg-blue-700 !bg-opacity-100': step == 4, 'group-hover:bg-opacity-100': step > 4 }"
                                    class="w-9 bg-gray-350 transition duration-200  h-9 ml-4 flex items-center justify-center rounded-lg bg-opacity-50">
                                    <CloudArrowUpIcon class="w-5 h-5 text-white" />
                                </span>
                                {{ __('Appendices') }}
                            </button>
                        </li>
                    </ul>
                    <div class="relative lg:hidden group mb-6 w-full" id="courses-page">
                        <div
                            class="dark:bg-base-300 bg-white cursor-pointer dark:text-white text-blue-700  py-3 flex items-center justify-between px-5 h-16 rounded">
                            <span class="flex font-medium text-lg items-center">
                                <span class="mr-2">{{ state }}</span>
                            </span>
                            <span class="border-r h-full flex items-center pr-5 border-blue-700 border-opacity-30 ">
                                <ChevronDownIcon class="w-5 h-5" />
                            </span>
                        </div>
                        <div class="absolute z-40 hidden top-full pt-3 w-full">
                            <ul class="bg-white dark:bg-base-300  px-2 space-y-2 py-3 rounded">
                                <li>
                                    <button @click="setStep(1)"
                                        :class="{ '!bg-blue-700 dark:!bg-base-100 !text-white ': step === 1 }"
                                        class="step-1 flex w-full items-center font-medium  text-chambray-400 pt-1  h-11 px-5 rounded-lg">
                                        <ClipboardDocumentListIcon class="w-5 h-5 ml-2 -mt-1" />
                                        {{ __('Opportunity information') }}
                                    </button>
                                </li>
                                <li>
                                    <button @click="setStep(2)"
                                        :class="{ '!bg-blue-700 dark:!bg-base-100 !text-white ': step === 2 }"
                                        class="step-2 flex items-center w-full font-medium text-chambray-400 pt-1 h-11 px-5 rounded-lg">
                                        <ChatBubbleOvalLeftEllipsisIcon class="w-5 h-5 ml-2 -mt-1" />
                                        {{ __('More information') }}
                                    </button>
                                </li>
                                <li>
                                    <button @click="setStep(3)"
                                        :class="{ '!bg-blue-700 dark:!bg-base-100 !text-white ': step === 3 }"
                                        class="step-3 flex items-center w-full font-medium text-chambray-400 pt-1 h-11 px-5 rounded-lg">
                                        <ShoppingBagIcon class="w-5 h-5 ml-2 -mt-1" />
                                        {{ __('Products') }}
                                    </button>
                                </li>
                                <li>
                                    <button @click="setStep(4)"
                                        :class="{ '!bg-blue-700 dark:!bg-base-100 !text-white ': step === 4 }"
                                        class="step-4 flex items-center w-full font-medium text-chambray-400 pt-1 h-11 px-5 rounded-lg">
                                        <CloudArrowUpIcon class="w-5 h-5 ml-2 -mt-1" />
                                        {{ __('Appendices') }}
                                    </button>
                                </li>
                            </ul>
                        </div>

                    </div>
                </div>
                <div class="xl:col-span-18 col-span-16">
                    <div class="flex justify-between items-center mb-3">
                        <h2 class="text-3xl font-bold">
                            {{ opportunity.id ? __('Edit opportunity') : __('Create opportunity') }}</h2>
                        <label for="note-sidebar" @click="openSidebar" class="btn btn-outline btn-primary btn-sm">
                            {{ __('Note') }}
                        </label>
                    </div>
                    <div class="bg-white dark:bg-base-300 rounded-2xl md:px-6 px-3 sm:pb-6 sm:pt-4 py-2">
                        <FormOpportunity :opportunity="opportunity" :step="step" :state="state" :modal="modal"
                            @setModal="setModal" @setStep="setStep" />
                    </div>
                </div>
            </section>
        </div>
    </div>
    <Teleport to="#app">
        <input type="checkbox" id="add-person-modal" class="modal-toggle" />
        <div class="modal" for="add-person-modal">
            <div class="modal-box max-w-7xl bg-base-200" for="">
                <label class="btn btn-sm btn-circle btn-ghost absolute left-2 top-2" for="add-person-modal">✕</label>
                <AddEditPerson v-if="modal == 'add-person-modal'" modal="add-person-modal" @setPerson="setPerson" />
            </div>
        </div>
    </Teleport>
    <Teleport to="#app">
        <input type="checkbox" id="add-account-modal" class="modal-toggle" />
        <div class="modal" for="add-account-modal">
            <div class="modal-box max-w-7xl bg-base-200" for="">
                <label class="btn btn-sm btn-circle btn-ghost absolute left-2 top-2" for="add-account-modal">✕</label>
                <AddEditAccount v-if="modal == 'add-account-modal'" modal="add-account-modal"
                    @setAccount="setAccount" />
            </div>
        </div>
    </Teleport>
    <Teleport to="#app" v-if="showSidebar && opportunity.id">
        <NoteSidebar type="opportunity" :id="opportunity.id" :title="opportunity.name" @close="closeSidebar" />
    </Teleport>
</template>

<script setup>
import { onMounted, ref } from 'vue';
import { CloudArrowUpIcon, InformationCircleIcon, ChatBubbleOvalLeftEllipsisIcon, ClipboardDocumentListIcon, ShoppingBagIcon, ChevronDownIcon } from "@heroicons/vue/24/outline";
const props = defineProps(['modal', 'opportunity']);
const step = ref(1);
const state = ref(window.i18n['Opportunity information']);
const modal = ref(null);
const { opportunity, meta, loading, addOpportunity, editOpportunity, errors, route } = useDashboard();
const showSidebar = ref(false);
const openSidebar = () => showSidebar.value = true;
const closeSidebar = () => setTimeout(() => showSidebar.value = false,200);
const setStep = (value) => {
    step.value = value;
    state.value = document.querySelector('.step-' + value)?.textContent?.trim();
};
const setPerson = (person) => {
    document.getElementById(modal.value).checked = false;
    modal.value = null;
    meta.person = [{ id: person.id, name: person.name }];
    opportunity.person_id = person.id;
}
const setAccount = (account) => {
    document.getElementById(modal.value).checked = false;
    modal.value = null;
    meta.account = [{ id: account.id, name: account.name }];
    opportunity.account_id = account.id;
}
const setModal = (id) => {
    modal.value = id;
    document.getElementById(id).checked = true;
}
const formKey = computed(() => JSON.stringify(opportunity))

const getData = () => {
    Object.assign(opportunity, props.opportunity || { id: route.params.id });
    if (opportunity.id) editOpportunity();
    else addOpportunity();
}
onMounted(() => getData());
</script>